import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useTranslation } from "react-i18next";
import { changeForm } from "../searchFlightsSlice";
import React from "react";

function IncludeCodeShareInput() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const includeCodeShare = useAppSelector(
    (state) => state.searchFlights.form.includeCodeShare
  );
  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);

  const onChange = () =>
    dispatch(changeForm({ includeCodeShare: !includeCodeShare }));

  return (
    <div className="field">
      <div className="control">
        <label
          className="checkbox"
          title={t("CHECKBOX_TITLE_INCLUDE_CODESHARE")}
        >
          <input
            type="checkbox"
            checked={includeCodeShare}
            disabled={disabled}
            onChange={onChange}
          />
          {t("CHECKBOX_INCLUDE_CODESHARE_FLIGHTS")}
        </label>
      </div>
    </div>
  );
}

export default IncludeCodeShareInput;
